import React, { Component } from 'react';
import SumaContexto from '../../contexto/SumaContexto';
import { withRouter } from "react-router-dom";
import { Spin, Progress } from 'antd';
import ServicioUsuarios from '../../servicios/usuarios/ServicioUsuarios'
import ServicioAdministracion from '../../servicios/ServicioAdministracion'
import { withCookies } from 'react-cookie';
import Constantes from '../../utilidades/Constantes'
import { Doughnut, Bar } from 'react-chartjs-2';



class EstadisticasUsuarios extends Component {

    static contextType = SumaContexto;

    ENUM_COMPONENTE = {
        CARGANDO: 1,
        VER: 2,
        NO_DISPONIBLE: 3,
        NO_HABILITADO: 4,
    }

    state = {
        componente: this.ENUM_COMPONENTE.CARGANDO,
        porcentaje: 0,
    };

    constructor(props) {
        super(props);
        this.servicioUsuarios = new ServicioUsuarios(props);
        this.servicioAdministracion = new ServicioAdministracion(props);
    }

    componentDidMount() {
        this._isMounted = true;
        this.cargarDatosIniciales();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }

    // -----------------------------------------------------------------------
    // --- CARGA DATOS INICIALES ---------------------------------------------
    // -----------------------------------------------------------------------
    async cargarDatosIniciales() {
        // Validando que el usuario esté en sesion
        let usr = await this.servicioUsuarios.usuarioEnSesion();
        if (usr != null) {
            // Valida que tenga la accion habilitada de acceder 
            let habilitado = await this.servicioUsuarios.accionHabilitadaPromesa(Constantes.ENUMS_MODULOS.REPORTES.ACCIONES.VER_ESTADISTICAS_USUARIOS.id);
            if (habilitado && habilitado.resultado) {
                let respuestaAPI = await this.servicioAdministracion.obtenerEstadisticasUsuarios();
                if (respuestaAPI && respuestaAPI.codigo === Constantes.ENUMS_API.ADMINISTRACION.DATOS_RETORNADOS.id) {
                    let vistaEstadisticasUsuario = respuestaAPI.resultado;
                    this.setSumaState({ vistaEstadisticasUsuario });

                    var contador = setInterval(
                        (function (self) {
                            return function () {
                                if (self && self.state && self.state.vistaEstadisticasUsuario) {
                                    let porcentaje = self.state.porcentaje + 1;
                                    let total = self.state.vistaEstadisticasUsuario.totalUsuarios;
                                    self.setSumaState({ porcentaje, total: parseInt((total / 100) * porcentaje) });
                                    if (porcentaje >= 100) {
                                        clearInterval(contador);
                                        self.setSumaState({ total });
                                    }
                                }
                            }
                        })(this),
                        1);
                }
                this.setSumaState({ usuario: usr, componente: this.ENUM_COMPONENTE.VER });
            } else {
                this.setSumaState({ usuario: usr, componente: this.ENUM_COMPONENTE.NO_HABILITADO });
            }
        } else {
            this.setSumaState({ componente: this.ENUM_COMPONENTE.NO_DISPONIBLE });
        }
    }


    render() {

        const { componente, vistaEstadisticasUsuario, porcentaje, total } = this.state;

        const dataEstados = canvas => {
            return {
                labels: [
                    'Activo',
                    'Inactivo',
                    'Creado',
                    'Bloqueado login',
                    'Activo SUMA1',
                    'Inactivo SUMA1',
                    'Suspendido SUMA1',
                    'Bloqueado SUMA1',

                ],
                datasets: [{
                    label: 'Estados usuarios',
                    data: [
                        vistaEstadisticasUsuario.estadoActivo,
                        vistaEstadisticasUsuario.estadoInactivo,
                        vistaEstadisticasUsuario.estadoCreado,
                        vistaEstadisticasUsuario.estadoBloqueadoIntentos,
                        vistaEstadisticasUsuario.estadoActivoSumav1,
                        vistaEstadisticasUsuario.estadoInactivoSumav1,
                        vistaEstadisticasUsuario.estadoSuspendidoSumav1,
                        vistaEstadisticasUsuario.estadoBloqueadoSumav1,
                    ],
                    backgroundColor: Object.values(Constantes.COLORES)
                }],
            };
        }

        const dataTipo = canvas => {
            return {
                labels: [
                    'Administrador',
                    'Persona Natural',
                    'Persona Jurídica',
                    'Entidad',
                    'Aplicación conectada',
                ],
                datasets: [{
                    label: 'Tipo usuarios',
                    data: [
                        vistaEstadisticasUsuario.tipoAdministrador,
                        vistaEstadisticasUsuario.tipoPersonaNatural,
                        vistaEstadisticasUsuario.tipoPersonaJuridica,
                        vistaEstadisticasUsuario.tipoEntidad,
                        vistaEstadisticasUsuario.tipoAplicacionConectada,
                    ],
                    backgroundColor: Object.values(Constantes.COLORES)
                }],
            };
        }

        const dataPersona = canvas => {
            return {
                labels: [
                    'Persona Jurídica',
                    'Persona Natural',
                ],
                datasets: [{
                    label: 'Tipo usuarios',
                    data: [
                        vistaEstadisticasUsuario.tipoPersonaJuridica,
                        vistaEstadisticasUsuario.tipoPersonaNatural,
                    ],
                    backgroundColor: Object.values(Constantes.COLORES)
                }],
            };
        }

        const opcionesPie = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'right',
                    labels: {
                        boxWidth: 10,
                    }
                }
            }
        };

        const opcionesBar = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false,
                    labels: {
                        boxWidth: 10,
                    }
                }
            }
        };


        return (
            <>
                <div className="seccion-principal contenedor-completo seccion-flex ">

                    <div className="division-contenido seccion-flex-grow-1 bkg-white contenido-usuarios">

                        {(componente === this.ENUM_COMPONENTE.VER) ?
                            (
                                <div className="graficas-antd">

                                    <div className="widget-grafica">
                                        <label>Total Usuarios</label>
                                        <div className="div-grafica">
                                            <Progress type="circle" percent={porcentaje}
                                                format={percent => total}
                                                width={200} />
                                        </div>
                                    </div>

                                    <div className="widget-grafica">
                                        <label>Usuarios por estado</label>
                                        <div className="div-grafica">
                                            <Bar data={dataEstados} options={opcionesBar} />
                                        </div>
                                    </div>

                                    <div className="widget-grafica">
                                        <label>Usuarios por tipo</label>
                                        <div className="div-grafica">
                                            <Doughnut data={dataTipo} options={opcionesPie} />
                                        </div>
                                    </div>

                                    <div className="widget-grafica">
                                        <label>Personas</label>
                                        <div className="div-grafica">
                                            <Doughnut data={dataPersona} options={opcionesPie} />
                                        </div>
                                    </div>

                                </div>
                            )
                            :
                            (componente === this.ENUM_COMPONENTE.NO_HABILITADO) ?
                                <>
                                    Estadísticas de usuarios no disponibles. {Constantes.MENSAJE_USUARIO_SIN_PERMISOS}
                                </> :
                                (componente === this.ENUM_COMPONENTE.CARGANDO) ?
                                    (<Spin tip="Por favor espera..." className="solo-spin-cargando" size="large" />)
                                    : ((componente === this.ENUM_COMPONENTE.NO_DISPONIBLE) ? (<label>Contenido no disponible. [Cod:REPOESTUSUA]</label>) : (<></>))

                        }
                    </div>
                </div>
            </>
        );

    }

}

export default withRouter(withCookies(EstadisticasUsuarios));